import type { ThemePackage } from './types';

/**
 * Structural theme registry (ADR Section 16). Keys here MUST match
 * backend/listing-service/src/config/constants.ts THEME_REGISTRY_KEYS exactly — the backend
 * validates PUT /api/v1/platform/theme against that list.
 *
 * Adding a fourth theme later is a real implementation task: build a new
 * frontend/src/themes/<key>/ package whose index.ts default-exports a ThemePackage (pages/auth/
 * dashboard, see types.ts), add one entry here, add the same key to the backend's
 * THEME_REGISTRY_KEYS. It then appears in the admin dropdown (SystemSettingsPage) automatically —
 * no other wiring required.
 */
export const THEME_REGISTRY: Record<string, () => Promise<{ default: ThemePackage }>> = {
  classic: () => import('./classic'),
  'glass-modern': () => import('./glass-modern'),
  basera: () => import('./basera'),
};

export type ThemeKey = keyof typeof THEME_REGISTRY;

export const THEME_KEYS = Object.keys(THEME_REGISTRY) as ThemeKey[];

export const THEME_LABELS: Record<ThemeKey, string> = {
  classic: 'Classic',
  'glass-modern': 'Glass Modern',
  basera: 'Basera',
};

export const DEFAULT_THEME: ThemeKey = 'basera';

export function isThemeKey(value: string | null | undefined): value is ThemeKey {
  return !!value && value in THEME_REGISTRY;
}
